var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainBlog = /* @__PURE__ */ __name(($el) => {
  var _a, _b, _c;
  const state = window.Alpine.reactive({
    loading: false,
    count: (_b = (_a = $el.querySelector("[data-next-url]")) == null ? void 0 : _a.children) == null ? void 0 : _b.length,
    next_url: (_c = $el.querySelector("[data-next-url]")) == null ? void 0 : _c.getAttribute("data-next-url")
  });
  const modalStore = window.Alpine.store("modal");
  const updateTagFilters = /* @__PURE__ */ __name(async (url) => {
    var _a2, _b2, _c2, _d, _e, _f, _g;
    modalStore.setId("");
    state.loading = true;
    if (!url) {
      url = new URL(`${(_a2 = $el.action) == null ? void 0 : _a2.split("?")[0]}?${new URLSearchParams(new FormData($el)).toString()}`);
      const tags = url.searchParams.getAll("Tags");
      url.search = "";
      url.pathname = (tags == null ? void 0 : tags.length) ? `${url.pathname.split("/tagged/")[0]}/tagged/${tags.join("+")}` : url.pathname.split("/tagged/")[0];
    }
    (_b2 = $el == null ? void 0 : $el.querySelectorAll(
      "[class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--]"
    )) == null ? void 0 : _b2.forEach((card) => {
      var _a3;
      (_a3 = card == null ? void 0 : card.classList) == null ? void 0 : _a3.add("button-loading-transparent");
    });
    const content = await fetch(url).then((res) => res.text());
    (_c2 = url == null ? void 0 : url.searchParams) == null ? void 0 : _c2.delete("barba_prefetch");
    barba.history.add(url.toString(), "barba", "replace");
    const newDocument = document.createElement("div");
    newDocument.innerHTML = content;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    $el.outerHTML = section.outerHTML;
    state.loading = false;
    state.count = (_e = (_d = $el.querySelector("[data-next-url]")) == null ? void 0 : _d.children) == null ? void 0 : _e.length;
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(0, (_g = (_f = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _f.bottom) != null ? _g : 0);
    utils.scrollToY(150, utils.getElementPosition($el).top - offsetHeight - +getComputedStyle($el).paddingTop.replace("px", ""));
  }, "updateTagFilters");
  const debounceUpdates = utils.debounce(updateTagFilters, 750);
  const loadNextPage = /* @__PURE__ */ __name(async (container = $el.querySelector(`[data-next-url]`), paginationContainer = $el.querySelector(`[data-pagination][x-ref="pagination"]`)) => {
    var _a2;
    if (!state.next_url || state.loading) return;
    state.loading = true;
    const html = await fetch(state.next_url).then((res) => res.text());
    const newDocument = document.createElement("div");
    newDocument.innerHTML = html;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    const newContent = section.querySelector(`[data-next-url][x-ref="${container == null ? void 0 : container.getAttribute("x-ref")}"]`);
    state.next_url = newContent == null ? void 0 : newContent.getAttribute("data-next-url");
    const newPagination = section.querySelector(`[data-pagination][x-ref="pagination"]`);
    if (newContent) {
      container.append(...newContent.children);
      state.count = (_a2 = container == null ? void 0 : container.children) == null ? void 0 : _a2.length;
    }
    if (paginationContainer && newPagination) {
      paginationContainer.innerHTML = newPagination.innerHTML;
    }
    state.loading = false;
  }, "loadNextPage");
  return {
    main_blog: {
      state,
      loadNextPage,
      updateSortAndFilters: updateTagFilters,
      debounceUpdates
    }
  };
}, "initMainBlog");
window._sections["initMainBlog"] = initMainBlog;
